import { z } from 'zod';
import { HydrateRunStatusSchema } from './hydrateOrg.js';
export const GetHydrateOrgStatusResponseSchema = z.object({
    status: HydrateRunStatusSchema,
    executionArn: z.string(),
    startedAt: z.string(),
    completedAt: z.string().optional(),
    error: z.string().optional(),
});
export const GetHydrateOrgStatusApiSchema = {
    response: GetHydrateOrgStatusResponseSchema,
};
